export default __webpack_public_path__ + "static/media/weather-app.e9f53a97.PNG";